import * as BABYLON from 'babylonjs';
import Node from '../node.js';
import { PARAM_TYPE, PARAM_UNITS } from '../connector.js';
import Utils3D from '../../utils/utils3D.js';
import Utils2D from '../../../utils/utils2D.js';
import GeoUtils from '../geoUtils.js';
import Extrude from '../../extrude.js';
import Spline from '../spline.js';
import CSG3D from '../../../../csg3d';

const CSG_LIB = CSG3D;
//const CSG_LIB = BABYLON;
const EPSILON = 1e-4;

export default class NodeSurfaceMould extends Node
{
	constructor(pParent)
	{
		super(pParent);

		this.addInput(PARAM_TYPE.GEOMETRY, 'geo', null);

		this.addInput(PARAM_TYPE.BOOLEAN, 'project_down', true);
		this.addInput(PARAM_TYPE.FLOAT, 'down_start_offset', 0.0, { minValue: 0, maxValue: 1, units: PARAM_UNITS.METERS });
		this.addInput(PARAM_TYPE.FLOAT, 'down_end_offset', 0.0, { minValue: 0, maxValue: 3, units: PARAM_UNITS.METERS });
		this.addInput(PARAM_TYPE.BOOLEAN, 'project_up', false);
		this.addInput(PARAM_TYPE.FLOAT, 'up_start_offset', 0.0, { minValue: 0, maxValue: 1, units: PARAM_UNITS.METERS });
		this.addInput(PARAM_TYPE.FLOAT, 'up_end_offset', 0.0, { minValue: 0, maxValue: 3, units: PARAM_UNITS.METERS });

		this.addOutput(PARAM_TYPE.GEOMETRY, 'geo');
	}

	getType()
	{ 
		return 'surfaceMould';
	}

	createProjectionMesh(vecDirection, pGeoList, scene)
	{
		vecDirection.normalize();

		let bbox = Utils3D.getObjectsBBoxWithChildren(pGeoList);
		let vecCenter = bbox.maximumWorld.add(bbox.minimumWorld).scale(0.5);

		//let shrinkage = new BABYLON.Vector3(0.01, 0.01, 0.01);
		//bbox.minimumWorld.addInPlace(shrinkage);
		//bbox.maximumWorld.subtractInPlace(shrinkage);

		let points = Utils3D.computeRotatedBBoxAllCorners(bbox.minimumWorld, bbox.maximumWorld);
		let projPoints = GeoUtils.projectPointsOntoPlane(points, vecDirection, BABYLON.Vector3.Zero());
		let projBBox2D = Utils2D.computePointsBBox(projPoints);
		let corners2D = [
			new BABYLON.Vector2(projBBox2D.minimumWorld.x, projBBox2D.minimumWorld.y),
			new BABYLON.Vector2(projBBox2D.maximumWorld.x, projBBox2D.minimumWorld.y),
			new BABYLON.Vector2(projBBox2D.maximumWorld.x, projBBox2D.maximumWorld.y),
			new BABYLON.Vector2(projBBox2D.minimumWorld.x, projBBox2D.maximumWorld.y),
		];

		let minProjExtent = Number.MAX_VALUE;
		let maxProjExtent = -Number.MAX_VALUE;
		for(let point of points)
		{
			let currDot = BABYLON.Vector3.Dot(vecDirection, point);
			if(currDot < minProjExtent)
				minProjExtent = currDot;
			if(currDot > maxProjExtent)
				maxProjExtent = currDot;
		}

		let fDist = (maxProjExtent - minProjExtent) + 1e-3;

		// Project the bbox onto the plane going through the center:
		let pathPoints = [
			vecDirection.scale(minProjExtent),
			vecDirection.scale(maxProjExtent),
		];
		let pathSpline = new Spline(pathPoints, false);

		let pArcMesh = Extrude.createMesh(`box`, {
				shape: corners2D,
				path: pathSpline,
				finalMeshAlign: 'toPath',
				cap: BABYLON.Mesh.CAP_ALL,
		}, scene);


		let currCSG = CSG_LIB.CSG.FromMesh(pGeoList[0]);
		for(let iVolume = 1; iVolume < pGeoList.length; iVolume++)
		{
			let pVolumeMesh = pGeoList[iVolume];
			let volumeCSG = CSG_LIB.CSG.FromMesh(pVolumeMesh);
			currCSG.unionInPlace(volumeCSG);
		}

		let geo1CSG = CSG_LIB.CSG.FromMesh(pArcMesh);
		geo1CSG.subtractInPlace(currCSG);
		let newMesh = geo1CSG.toMesh('proj', pGeoList[0].material, scene);
		this.onMeshCreated(newMesh);

		pArcMesh.dispose();

		return newMesh;
	}

	createProjectionMeshOLD(vecDirection, pGeoList, scene)
	{
		let bbox = Utils3D.getObjectsBBoxWithChildren(pGeoList);
		let vecCenter = bbox.maximumWorld.add(bbox.minimumWorld).scale(0.5);

		// Find a plane distance that's just touchign the bbox
		let srcVertexPositions = Utils3D.getMeshesGlobalVertexPositions(pGeoList);
		let fMinDist = Number.MAX_VALUE;
		let fMaxDist = -Number.MAX_VALUE;
		for(let vertexInfo of srcVertexPositions)
		{
			let currDist = BABYLON.Vector3.Dot(vecDirection, vertexInfo.pos.subtract(vecCenter));
			if(currDist > fMaxDist)
				fMaxDist = currDist;
			if(currDist < fMinDist)
				fMinDist = currDist;
		}

		// TODO: Proper box dimesniosn with offsets if need be
		// Create a box oriented that way
		let fThickness = 0.2;
		let fExtraDirectionalDist = 0.0;
		let pResBox = BABYLON.MeshBuilder.CreateBox(this.getGeneratedMeshName(), { 
			width: 2, 
			depth: fThickness, 
			height: 2,
			sideOrientation: BABYLON.Mesh.FRONTSIDE,
			updatable: true
		}, scene);

		//pResBox.position = vecCenter.add(vecDirection.scale((fMaxDist - fMinDist)/2.0 + fThickness/2 + fExtraDirectionalDist));
pResBox.position.addInPlace(vecDirection.scale((fMaxDist - fMinDist)/2.0 + fThickness/2 + fExtraDirectionalDist));
		pResBox.lookAt(pResBox.position.subtract(vecDirection));
		pResBox.computeWorldMatrix(true);
//pResBox.increaseVertices(32);

		GeoUtils.applyBoxUVsToMeshes([pResBox]);
		pResBox.material = new BABYLON.StandardMaterial(`boxtest`, scene);
		pResBox.material.diffuseTexture = new BABYLON.Texture(`http://localhost:3003/textures/uvmap.png`);

		//pResBox.forceSharedVertices();

		let bDidSplit;
		bDidSplit = GeoUtils.splitFace(pResBox, new BABYLON.Vector3(0.25, -0.5, 0.25));
		//let bDidSplit = GeoUtils.splitFace(pResBox, new BABYLON.Vector3(0, -0.5, 0));
		//bDidSplit = GeoUtils.splitFace(pResBox, new BABYLON.Vector3(0, -0.5, -1));
		//bDidSplit = GeoUtils.splitFace(pResBox, new BABYLON.Vector3(0, -0.5, 0));
		//bDidSplit = GeoUtils.splitFace(pResBox, new BABYLON.Vector3(-0.25, -0.5, -0.25));
		//bDidSplit = GeoUtils.splitFace(pResBox, new BABYLON.Vector3(-1, -0.5, -1));
		console.log(`Did split = ${bDidSplit}`);

		let nonNullMeshes = pGeoList.filter((mesh) => { return !!mesh; });
		let vecNegatedDir = vecDirection.scale(-1.0);

		let boxVerts = Utils3D.getMeshVertexGlobalPositions(pResBox);

		let worldMatrix = pResBox.getWorldMatrix();
		let invertedWorldMat = new BABYLON.Matrix();
		worldMatrix.invertToRef(invertedWorldMat);

		let mapProcessedVerts = {};
		let iSplitCount = 0;

		// Project all vertices onto it, subdivide and adjust height
		let pRay = new BABYLON.Ray();
		let vecLocalSpaceVertex = BABYLON.Vector3.Zero();
/*
		for(let vertInfo of srcVertexPositions)
		{
			if(mapProcessedVerts[vertInfo.uniqueId])
				continue;
			// First, proejct down:
			pRay.origin = vertInfo.pos;
			pRay.direction = vecDirection;
			let pickInfo = pRay.intersectsMesh(pResBox, false);
			// Check if we even hit the surface mould mesh
			if(!pickInfo.hit)
				continue;
			// Get the closest vertex on this ray. There might be several (think sphere):
			let fMinPickDistance = Number.MAX_VALUE;
			for(let innerVertInfo of srcVertexPositions)
			{
				let vecToRayOrigin = innerVertInfo.pos.subtract(pickInfo.pickedPoint);
				let fDist = vecToRayOrigin.length();
				vecToRayOrigin.normalize();
				let fDotProd = BABYLON.Vector3.Dot(vecToRayOrigin, vecNegatedDir);
				if(fDotProd < 1.0 - EPSILON)
					continue;
				mapProcessedVerts[innerVertInfo.uniqueId] = true;
				if(fDist < fMinPickDistance)
					fMinPickDistance = fDist;
			}
			if(fMinPickDistance === Number.MAX_VALUE)
				continue;
			// Otherwise, check if we already have a vertex at this location in the source mesh:
			let vertexIndexToMove = -1;
			for(let innerVertInfo of boxVerts)
			{
				if(BABYLON.Vector3.Distance(innerVertInfo.pos, pickInfo.pickedPoint) < EPSILON)
				{
					// Move the vertex and skip the rest
					vertexIndexToMove = innerVertInfo.index;
					// TODO: Implement
					break;
				}
			}
			// If we don't, split the face, update our vert and face infos
			if(vertexIndexToMove < 0)
			{
// TODO: Check if we're on an edge and need to do a two-way split only
				let oldPositions = pResBox.getVerticesData(BABYLON.VertexBuffer.PositionKind);
				let oldNormals = pResBox.getVerticesData(BABYLON.VertexBuffer.NormalKind);
				let oldUvs = pResBox.getVerticesData(BABYLON.VertexBuffer.UVKind);
				let indices = pResBox.getIndices();
				let positions = new Float32Array(oldPositions.length + 3);
				positions.set(oldPositions);
				let normals = new Float32Array(oldNormals.length + 3);
				normals.set(oldNormals);
				let uvs = new Float32Array(oldUvs.length + 2);
				uvs.set(oldUvs);
				let faceIndex = pickInfo.faceId*3;
				////let vecGlobalNewVertexPos = pickInfo.pickedPoint.add(vecNegatedDir.scale(fMinPickDistance - fExtraDirectionalDist));
				let vecGlobalNewVertexPos = pickInfo.pickedPoint;
				BABYLON.Vector3.TransformCoordinatesToRef(vecGlobalNewVertexPos, invertedWorldMat, vecLocalSpaceVertex);
				let pointIndex = indices[faceIndex];
				let newPointIndex = oldPositions.length;
				positions[newPointIndex] = vecLocalSpaceVertex.x;
				positions[newPointIndex + 1] = vecLocalSpaceVertex.y;
				positions[newPointIndex + 2] = vecLocalSpaceVertex.z;
				let newNormalIndex = oldNormals.length;
				normals[newNormalIndex] = oldNormals[pointIndex*3];
				normals[newNormalIndex + 1] = oldNormals[pointIndex*3 + 1];
				normals[newNormalIndex + 2] = oldNormals[pointIndex*3 + 2];
				// TODO: UVs
				let newUVsIndex = oldUvs.length;
				uvs[newUVsIndex] = 0;
				uvs[newUVsIndex + 1] = 0;
				let oldVertexIndex1 = indices[faceIndex];
				let oldVertexIndex2 = indices[faceIndex + 1];
				let oldVertexIndex3 = indices[faceIndex + 2];
				let iNewPointIndex = newPointIndex/3;
				// TODO: we need to check for proper clockwise orientation
				indices[faceIndex] = oldVertexIndex1;
				indices[faceIndex + 1] = oldVertexIndex2;
				indices[faceIndex + 2] = iNewPointIndex;
				
				indices.push(iNewPointIndex);
				indices.push(oldVertexIndex3);
				indices.push(oldVertexIndex1);
				indices.push(oldVertexIndex2);
				indices.push(oldVertexIndex3);
				indices.push(iNewPointIndex);
				
				let vertexData = new BABYLON.VertexData();
				vertexData.positions = positions;
				vertexData.indices = indices;
				vertexData.normals = normals;
				vertexData.uvs = uvs;
				vertexData.applyToMesh(pResBox);
				iSplitCount++;
				boxVerts = Utils3D.getMeshVertexGlobalPositions(pResBox);
			}
//if(iSplitCount >= 3)
	//break;
		}
*/
		/*
		// Now, go through every mesh vertex and shoot rays towards our target:
		let positions = pResBox.getVerticesData(BABYLON.VertexBuffer.PositionKind);
		for(let vertInfo of boxVerts)
		{
// TODO: Filter by normals somehow?
if(vertInfo.pos.y < pResBox.position.y + fThickness/2 - EPSILON)
	continue;
			pRay.origin = vertInfo.pos;
			pRay.direction = vecNegatedDir;
			let fMinDist = Number.MAX_VALUE;
			let pickInfos = pRay.intersectsMeshes(pGeoList, false);
			for(let pickInfo of pickInfos)
			{
				if(pickInfo.distance < fMinDist)
					fMinDist = pickInfo.distance;
			}
			// Now, set the vert
			if(fMinDist === Number.MAX_VALUE)
			{
				let vecToCenter = vecCenter.subtract(vertInfo.pos);
				fMinDist = BABYLON.Vector3.Dot(vecToCenter, vecNegatedDir);
			}
			let vecGlobalNewVertexPos = vertInfo.pos.add(vecNegatedDir.scale(fMinDist - fExtraDirectionalDist));
			BABYLON.Vector3.TransformCoordinatesToRef(vecGlobalNewVertexPos, invertedWorldMat, vecLocalSpaceVertex);
			positions[vertInfo.index] = vecLocalSpaceVertex.x;
			positions[vertInfo.index + 1] = vecLocalSpaceVertex.y;
			positions[vertInfo.index + 2] = vecLocalSpaceVertex.z;
		}
		pResBox.setVerticesData(BABYLON.VertexBuffer.PositionKind, positions);
		*/
///pResBox.convertToFlatShadedMesh();
		this.onMeshCreated(pResBox);
		return pResBox;
	}

	generateSubclass(scene, inputValues, outputName, computedOutputResults)
	{
		let pGeoList = inputValues['geo'];
		if(!pGeoList || pGeoList.length === 0)
			return null;

		let pResMeshes = [];
		if(inputValues['project_down'])
			//pResMeshes.push(this.createProjectionMesh(new BABYLON.Vector3(-1, -1, 0).normalize(), pGeoList, scene));
			pResMeshes.push(this.createProjectionMesh(new BABYLON.Vector3(0, -1, 0), pGeoList, scene));
		if(inputValues['project_up'])
			pResMeshes.push(this.createProjectionMesh(new BABYLON.Vector3(0, 1, 0), pGeoList, scene));
		
		return pResMeshes;
	}
}